module.exports = __webpack_public_path__ + "img/jf.cb469c7f.png";